import { differenceInHours, differenceInMinutes} from "date-fns";


const duration = {
    calculateDuration: function(sleepStart, sleepEnd) {
        const startTime = duration.timeStringToNumber(sleepStart, "both");
        const endTime = duration.timeStringToNumber(sleepEnd, "both");
        let diff = endTime - startTime;
        if (diff < 0) {
            const sleepEndHours = duration.timeStringToNumber(sleepEnd, "hours");
            const sleepEndMinutes = duration.timeStringToNumber(sleepEnd, "minutes");
            const sleepStartHours = duration.timeStringToNumber(sleepStart, "hours");
            const sleepStartMinutes = duration.timeStringToNumber(sleepStart, "minutes");
            const endDate = new Date(2014, 6, 3, sleepEndHours, sleepEndMinutes);
            const startDate = new Date(2014, 6, 2, sleepStartHours, sleepStartMinutes);
            let diffHours = differenceInHours(endDate, startDate);
            let diffMinutes = differenceInMinutes(endDate, startDate);
            diffMinutes = diffMinutes - (diffHours * 60);
            diff = diffHours + (diffMinutes / Math.pow(10, 2));
        }
        return diff;
    },
    
    
    timeStringToNumber: function(time, returnType) {
        const hoursMinutes = time.split(/[.:]/);
        const hours = parseInt(hoursMinutes[0], 10);
        const minutes = hoursMinutes[1] ? parseInt(hoursMinutes[1], 10) : 0;
        if (returnType === "both") {
            return (hours + minutes / 60).toFixed(2);
        } else if (returnType === "minutes") {
            return minutes;
        }
        else {
            return hours;
        }
    }

}
 export default duration;